document.addEventListener('DOMContentLoaded', () => {
  const slideshowSections = document.querySelectorAll('.homepage-slideshow');

  slideshowSections.forEach((section) => {
    const slides = section.querySelectorAll('.homepage-slideshow__slide');

    // No slideshow needed if there are fewer than 2 slides
    if (slides.length < 2) {
      return;
    }

    const duration =
      parseInt(section.dataset.duration, 10) * 1000 || 5000;

    let currentSlide = 0;

    // Activate first slide immediately
    slides[currentSlide].classList.add('is-active');

    setInterval(() => {
      // Remove active class from current slide
      slides[currentSlide].classList.remove('is-active');

      // Increment slide index
      currentSlide++;

      // Loop back to beginning if needed
      if (currentSlide >= slides.length) {
        currentSlide = 0;
      }

      // Activate next slide
      slides[currentSlide].classList.add('is-active');
    }, duration);
  });
});

// function updateButtonText() {
//     const button = document.querySelector('.homepage-slideshow__button');
//     if (!button) return;

//     if (window.innerWidth >= 940) {
//         button.textContent = 'LEARN MORE ABOUT DONN AND DON THE BEACHCOMBER';
//     } else {
//         button.textContent = 'LEARN MORE ABOUT DONN';
//     }
// }

// updateButtonText();

// window.addEventListener('resize', updateButtonText);